import Customers from './Customers.vue'
import CreateCustomer from './CreateCustomer.vue'
import CustomerList from './CustomerList.vue'
import CustomerDetails from './CustomerDetails'
export default {
    path: 'customers', component: Customers, children: [
        {
            path:'', component: CustomerList, meta: { protected: true }
        },
        {
            path:'create', component: CreateCustomer,
        },
        {
            path:':id', component: CustomerDetails
        }
    ]
}

